import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query niboBankAccounts($integrationId: Int, $page: Int) {
    niboBankAccounts(integrationId: $integrationId, page: $page, limit: 30) {
      id
      name
    }
  }
`

export const useCategorySelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'niboBankAccounts']))
      .then(data => {
        return data
      })
  }
}

const BankAccountsSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useCategorySelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default BankAccountsSelect
